import React, { Fragment, useState, useEffect } from 'react';
import './home.css';
import Spinner from '../../components/Spinner';
import { batch, useDispatch, useSelector } from 'react-redux';
import {
  getDefiChainData,
  getExchangeAssetData,
  getHomePerformanceSummary,
  getQuarterlyPerformance,
  homeOverviewSelector,
} from '../../store/home/slice';
import QuarterlyPerformance from './components/QuarterlyPerformance';
import AssetBreakdown from './components/AssetBreakdown';
import ChainSplit from './components/ChainSplit';
import { authSelector } from '../../store/auth/slice';

const Index = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(authSelector);
  const [loading, setLoading] = useState(false);
  const {
    quarterly_performance,
    performance_summary,
    availableChains,
    tokenChainBeakdown,
    chainTotalAmounts,
    exchangeSplit,
    assetBreakdown,
    balanceBreakdown,
  } = useSelector(homeOverviewSelector);
  const [quarterlyPerformance, setQuarterlyPerformance] = useState([]);
  const [performanceSummary, setPerformanceSummary] = useState([]);

  useEffect(() => {
    batch(() => {
      dispatch(getQuarterlyPerformance());
      dispatch(getHomePerformanceSummary());
      dispatch(getDefiChainData());
      dispatch(getExchangeAssetData());
    });
  }, [dispatch]);

  useEffect(() => {
    setQuarterlyPerformance(quarterly_performance);
    setPerformanceSummary(performance_summary);
  }, [quarterly_performance, performance_summary]);

  useEffect(() => {
    setLoading(true);

    let timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Fragment>
      {loading ? (
        <Spinner />
      ) : (
        <div className="custom_dashboard">
          {user?.account_type === 'standard' && user?.role === 'user' ? null : (
            <div className="" style={{ width: '100%', overflow: 'hidden' }}>
              <QuarterlyPerformance
                data={quarterlyPerformance}
                performance_summary={performanceSummary}
              />
            </div>
          )}

          <div>
            <div style={{ width: '100%', display: 'flex' }}>
              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit chain_total_amounts={exchangeSplit} title="Exchange Split" />
              </div>

              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit
                  chain_total_amounts={assetBreakdown}
                  title="Exchange Assets Breakdown"
                />
              </div>

              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit
                  chain_total_amounts={balanceBreakdown}
                  title="Exchange Balance Breakdown"
                />
              </div>
            </div>

            <div style={{ width: '100%', display: 'flex' }}>
              <div style={{ width: '66.66%' }}>
                <AssetBreakdown
                  chain_asset_breakdown={tokenChainBeakdown}
                  available_chains={availableChains}
                  title="Defi Assets Breakdown"
                />
              </div>
              <div style={{ width: '33.33%', marginTop: '0.6rem' }}>
                <ChainSplit chain_total_amounts={chainTotalAmounts} title="Defi Chain Split" />
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Index;
